import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'registerForm.title',
    defaultMessage: 'Create an account',
  },
  description: {
    id: 'registerForm.description',
    defaultMessage:
      'Create an account to create and manage your bookings. ' +
      'We won’t keep you logged in or save your information on this device.',
  },
  emailPlaceholder: {
    id: 'registerForm.emailPlaceholder',
    defaultMessage: 'Email address',
  },
  firstNamePlaceholder: {
    id: 'registerForm.firstNamePlaceholder',
    defaultMessage: 'First name',
  },
  lastNamePlaceholder: {
    id: 'registerForm.lastNamePlaceholder',
    defaultMessage: 'Last name',
  },
  agreements1Placeholder: {
    id: 'registerForm.agreements1Placeholder',
    defaultMessage: 'I consent to receiving inspiration, special offers and policy updates via email',
  },
  agreements2Placeholder: {
    id: 'registerForm.agreements2Placeholder',
    defaultMessage: 'I have read and agree to Winnow’s {termsLink}',
  },
  termsLinkLabel: {
    id: 'registerForm.termsLinkLabel',
    defaultMessage: 'Terms and Conditions',
  },
  passwordPlaceholder: {
    id: 'registerForm.passwordPlaceholder',
    defaultMessage: 'Password',
  },
  submitButton: {
    id: 'registerForm.submitButton',
    defaultMessage: 'Create an account',
  },
  haveAnAccount: {
    id: 'registerForm.haveAnAccount',
    defaultMessage: 'Already have a Winnow account?',
  },
  login: {
    id: 'registerForm.login',
    defaultMessage: 'Log in',
  },
  fieldRequired: {
    id: 'registerForm.fieldRequired',
    defaultMessage: 'This field is required',
  },
  incorrectEmailFormat: {
    id: 'registerForm.incorrectEmailFormat',
    defaultMessage: 'This is not a valid e-mail format',
  },
});
